import { BASIC_INITIAL_STATE } from '../../utils/HttpHelper';
import getPersonAcknowledgementInfo from './GetPersonAcknowledgementInfo';
import getPersonAcknowledgementInfoByMemberId from './GetPersonAcknowledgementInfoByMemberId';

const INITIAL_STATE = { ...BASIC_INITIAL_STATE };

const PersonAcknowledgementInfoData = { INITIAL_STATE, getPersonAcknowledgementInfo, getPersonAcknowledgementInfoByMemberId };

export default PersonAcknowledgementInfoData;